import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './containers/App/App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Admin application root element was not found.');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
